module.exports = __webpack_public_path__ + "img/didi.d9d297ae.png";